// 走班选课
const ClassSelection = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/class/ClassGo.vue')
// 签字通知
const FileSign = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/sign/Sign.vue')
const SignDetails = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/sign/SignDetails.vue')
const Signing = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/sign/Signing.vue')
// 学生考勤
const StudentAttendance = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/att/Att.vue')
// 校本选课
const BaseClassSelection = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/school/School.vue')

// 学生请假列表
const StudentLeave = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/studentLeave/HStudentLeaveSubApplication.vue')

// 学生请假
const StudentLeaveSubCreate = () => import( /* webpackChunkName: "basic" */ '@/pages/homeSchool/views/studentLeave/HStudentLeaveSubCreate.vue')
// const StudentLeave = () => import( /* webpackChunkName: "homeSchool" */ '@/pages/homeSchool/views/leave/Leave.vue')

//访客邀请-进入链接
const InvitationLink = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/InvitationLink.vue')
const homeSchool = [
  {
    path: 'ClassSelection',
    name: 'ClassSelection',
    component: ClassSelection
  },
  {
    path: 'FileSign',
    name: 'FileSign',
    component: FileSign
  },
  {
    path: 'SignDetails',
    name: 'SignDetails',
    component: SignDetails
  },
  {
    path: 'Signing',
    name: 'Signing',
    component: Signing
  },
  {
    path: 'StudentAttendance',
    name: 'StudentAttendance',
    component: StudentAttendance
  },
  {
    path: 'BaseClassSelection',
    name: 'BaseClassSelection',
    component: BaseClassSelection
  },
  {
    path: 'StudentLeave',
    name: 'StudentLeave',
    component: StudentLeave
  },
  {
    path: 'StudentLeaveSubCreate',
    name: 'StudentLeaveSubCreate',
    component: StudentLeaveSubCreate
  },
  {
    path: 'InvitationLink',
    name: 'InvitationLink',
    component: InvitationLink,
    /* 动态配置title */
    meta: {
        title: '受邀详情'
    }
  },
]
export default homeSchool
